import MessagePush from '../views/systemMessage/messagePush';
import EmailPush from '../views/systemMessage/emailPush';
import Main from '../views/main';
const SystemMessageRouter = {
  path: '/message-push',
  component: Main,
  title: '系统消息',
  icon: 'el-icon-message-solid',
  meta: { keepAlive: true },
  children: [
    {
      path: '/message-push',
      component: MessagePush,
      name: 'messagePush',
      title: '消息推送',
      meta: { title: '消息推送' ,keepAlive:true}
    },
    {
      path: '/email-push',
      component: EmailPush,
      name: 'emailPush',
      title: '邮件推送',
      meta: { title: '邮件推送' ,keepAlive:true}
    }
  ]
};
export default SystemMessageRouter;
